import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Redirect } from "react-router-dom";
import { Button, Form, notification } from "antd";

// STYLES
import { ParentWrapper, InputWrapper, PasswordWrapper } from "./Login.style";
// CONST
import { URL_DASHBOARD } from "Helpers/Paths";
import { loginUser } from "Redux/Auth/Actions";

// IMAGES
import Api from "Helpers/ApiHandler";
import { API_URL } from "Helpers";
import SubjectsMasterLogo from "Assets/Images/AuthImages/subjects-master-logo.svg";
import ButtonArrow from "Assets/Images/AuthImages/btn_arrow.svg";

//MODAL
import SubscriptionModal from "Components/Pages/Login/SubscriptionModal/SubscriptionModal";

function Login(props) {
	const isLoggedIn = useSelector((state) => state.Auth.isLoggedIn);
	const getAccessToken = new URLSearchParams(props?.location?.search);
	const AccessToken = getAccessToken.get("token");

	const dispatch = useDispatch();

	useEffect(() => {
		if (AccessToken) {
			// Entered via the Website teacher/school portal (login?token=...).
			// Tag this tab so an auth failure returns them to the teacher portal.
			sessionStorage.setItem("cms_loginPortal", "teacher");
			sessionStorage.setItem("cms_accessToken", AccessToken);
			dispatch(loginUser());
		}
		// eslint-disable-next-line
	}, []);

	const [loading, setLoading] = useState(false);

	const [isForgotPassClick, setIsForgotPassClick] = useState(false);

	const [isSubscriptionModalOpen, setIsSubscriptionModalOpen] = useState(false);

	const [subscriptionDetails, setSubscriptionDetails] = useState({
		schoolId: "",
		message: "",
		isAlreadyRegistered: false,
	});

	// If already logged in (or a token is being processed), skip the login form entirely
	if (isLoggedIn || AccessToken) return <Redirect to={URL_DASHBOARD} />;

	async function login(values) {
		try {
			setLoading(true);

			const response = await new Api().post(API_URL.CMS_LOGIN, {
				data: {
					email: values.username,
					password: values.password,
				},
			});

			if (response.status === 200 || response.status === 201) {
				// Direct CMS login form = admin portal entry for this tab.
				sessionStorage.setItem("cms_loginPortal", "admin");
				sessionStorage.setItem("cms_accessToken", response.data);
				dispatch(loginUser());
				props.history.push(URL_DASHBOARD);
			} else if (response.status === 423) {
				//SUBSCRIPTION NOT TAKEN
				const data = response?.data;
				setSubscriptionDetails({
					schoolId: data?.data,
					message: data?.message,
					isAlreadyRegistered: data?.isAlreadyRegistered,
				});
				setIsSubscriptionModalOpen(true);
			}
			setLoading(false);
		} catch (err) {
			console.log("err:", err);
			setLoading(false);
		}
	}

	const forgotPassClick = () => {
		setIsForgotPassClick(true);
	};

	function cancelClick() {
		setIsForgotPassClick(false);
	}

	async function clickForgotPassword(values) {
		const formData = new FormData();
		formData.append("email", values.forgotPassword);
		let response = await new Api().post(API_URL.ADMIN_FORGOT_PASSWORD, { data: formData });
		if (response.status === 200 || response.status === 201) {
			setIsForgotPassClick(false);
			notification.success({ message: "Success", description: response?.message, duration: 3 });
		} else {
			setIsForgotPassClick(false);
		}
	}

	const handleRedirectToSubscription = () => {
		window.location.href = `${process.env.REACT_APP_WEBSITE_URL}subscription?id=${subscriptionDetails?.schoolId}&isAlreadyRegistered=${subscriptionDetails?.isAlreadyRegistered}`;
	};

	const handleCancel = () => {
		setIsSubscriptionModalOpen(false);
	};

	return (
		<ParentWrapper isForgotPassword={isForgotPassClick}>
			<div className="auth-wrap-left">
				<div className="auth_wrap_logo">
					<img src={SubjectsMasterLogo} alt="Subjects Master" className="auth_logo" />
				</div>
				<div className="auth_wrap_left_in">
					<h1>
						Welcome to <br /> <span className="redfont">Subjects Master</span>
					</h1>
					<p>
						Welcome back to the Subjects Master Admin Portal! Here’s where you can manage schools, users and content, keep subjects and games up to date, and access all the tools that keep
						the platform running smoothly.
					</p>
				</div>
			</div>

			<div className="auth_wrap_right">
				<div className="auth_right_inner">
					{!isForgotPassClick && (
						<React.Fragment>
							<div className="auth_right_head">
								<h2>Admin Portal Login</h2>
								<h4 className="redfont">Your Adventure in Learning Starts Here</h4>
							</div>

							<Form onFinish={login}>
								<div className="field_wrapper">
									<p className="text">Email address</p>
									<Form.Item name="username" rules={[{ required: true, message: "Please input email." }]}>
										<InputWrapper size="large" className="login" placeholder="Email address" />
									</Form.Item>
								</div>

								<div className="field_wrapper">
									<p className="text">Password</p>
									<Form.Item name="password" rules={[{ required: true, message: "Please input password." }]}>
										<PasswordWrapper size="large" className="login" placeholder="Enter password" flag="password" />
									</Form.Item>
								</div>

								<div className="forgot-password-parent">
									<span className="forgot-password" onClick={() => forgotPassClick()}>
										Forgot Password?
									</span>
								</div>

								<div className="login_btn_divs">
									<div className="login-button-parent">
										<Button className="customs_btn" htmlType="submit" loading={loading}>
											Login
											<span className="btn_arrow_wrap">
												<img src={ButtonArrow} alt="" />
											</span>
										</Button>
									</div>
								</div>
							</Form>
						</React.Fragment>
					)}

					{isForgotPassClick && (
						<React.Fragment>
							<div className="auth_right_head">
								<h2>Forgot Password</h2>
								<h4 className="redfont">We’ll Email You A Reset Link</h4>
							</div>

							<Form className="login-form-container" onFinish={clickForgotPassword}>
								<div className="field_wrapper">
									<p className="text">Email address</p>
									<Form.Item name="forgotPassword" rules={[{ required: true, message: "Please input your email." }]}>
										<InputWrapper size="large" className="login" placeholder="Email address" />
									</Form.Item>
								</div>

								<div className="login_btn_divs">
									<div className="login-button-parent">
										<Button className="customs_btn ghost_btn" htmlType="reset" onClick={cancelClick}>
											Cancel
										</Button>
										<Button className="customs_btn" htmlType="submit" loading={loading}>
											Submit
											<span className="btn_arrow_wrap">
												<img src={ButtonArrow} alt="" />
											</span>
										</Button>
									</div>
								</div>
							</Form>
						</React.Fragment>
					)}

					{isSubscriptionModalOpen && (
						<SubscriptionModal
							setIsSubscriptionModalOpen={setIsSubscriptionModalOpen}
							isSubscriptionModalOpen={isSubscriptionModalOpen}
							handleRedirectToSubscription={handleRedirectToSubscription}
							handleCancel={handleCancel}
							subscriptionDetails={subscriptionDetails}
						/>
					)}
				</div>
			</div>
		</ParentWrapper>
	);
}

export default Login;
